import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import ArtApi from '../api/ArtApi';


interface IUserInfoProps {
    userId: string
}

export default function UserInfo(props: IUserInfoProps) {
    const [error, setError] = useState<string | null>(null);
    const [userName, setUserName] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        ArtApi.getUserName(props.userId)
            .then(response => {
                setUserName(response.response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    }, [props.userId]);

    return (
        <div>
            {isLoading && <CircularProgress color="secondary" />}
            {error}
            {userName}
        </div>
    )
}